export const SET_VIEW_GRID = "SET_VIEW_GRID";
export const SET_VIEW_FULL = "SET_VIEW_FULL";
